import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav7").addClass("active");
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
var swiper = new Swiper(".section1 .mySwiper", {
    slidesPerView: 1.314,
    spaceBetween: '7.28%',
    pagination: {
      el: ".section1 .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768      
            slidesPerView: 1.314,
            spaceBetween: '7.28%',
        },
    },
});
$(".join-nav li").eq(0).addClass("active");
$(".join-list .content").eq(0).addClass("active");
$(".join-nav .swiper-slide").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".join-list .content").eq(index).addClass("active").siblings().removeClass("active");
})
var swiper = new Swiper(".section2 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '2.4%',
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        },
        768: { //当屏幕宽度大于等于768      
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: '2.4%',
        },
        1280: { //当屏幕宽度大于等于768      
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: '2.4%',
        },
    },
});